import type { ReactNode } from 'react';

/**
 * A section of a form or page. Its title sits in a dark pill centred on the
 * top edge ("dynamic island"), so every block is named the same way and the
 * inside of the block is left for its content.
 */
export function FormBlock({
  title,
  children,
  className = '',
  bodyClassName = 'px-5 pb-5 pt-7',
}: {
  title: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}) {
  return (
    <section className={`relative bg-white rounded-2xl border border-gray-200 shadow-sm ${className}`}>
      <BlockIsland>{title}</BlockIsland>
      <div className={bodyClassName}>{children}</div>
    </section>
  );
}

export function BlockIsland({ children }: { children: ReactNode }) {
  return (
    <h3 className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[1] max-w-[calc(100%-2rem)] truncate px-4 py-1 rounded-full bg-brand-ink text-white text-xs font-semibold tracking-wide whitespace-nowrap shadow-sm">
      {children}
    </h3>
  );
}
